export const themes = [
    { id: 1, name: 'primaryTheme', value: 'is-primary' },
    { id: 2, name: 'linkTheme', value: 'is-link' },
    { id: 3, name: 'infoTheme', value: 'is-info' },
    { id: 4, name: 'successTheme', value: 'is-success' },
    { id: 5, name: 'warningTheme', value: 'is-warning' },
    { id: 6, name: 'dangerTheme', value: 'is-danger' },
    { id: 7, name: 'blackTheme', value: 'is-black' },
    { id: 8, name: 'darkTheme', value: 'is-dark' },
    { id: 9, name: 'lightTheme', value: 'is-light' },
    { id: 10, name: 'whiteTheme', value: 'is-white' },
]
